/* @flow */

// localstorage with expire control

class Storage {
  setItem(key: string, value: any, expire: number = 3600) {
    const val = {
      value,
      expire: Date.now() + expire * 1000,
    };
    try {
      localStorage.setItem(key, JSON.stringify(val));
    } catch (err) {
      // noop
    }
  }

  getItem(key: string): any {
    let item;
    try {
      // $FlowFixMe
      const { value, expire } = JSON.parse(localStorage.getItem(key)) || {};
      if (value && Date.now() < expire) {
        item = value;
      } else {
        localStorage.removeItem(key);
      }
    } catch (err) {
      // noop
    }
    return item;
  }
}

export default new Storage();
